import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { appName } from '../../../utils/Variables';
import { apiUrl } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Modal, Collapse, Card } from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import PageTitle from '../../../containers/PageTitle';
import ReactFileReader from 'react-file-reader';
import { Cropper } from 'react-image-cropper'
import Toggle from 'react-bootstrap-toggle';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";

const styles = {
	cardTitle: {
		paddingBottom: '5px',
		backgroundColor: '#ffd3e7',
		padding: '5px',
		fontSize: '15px',
		fontWeight: '700',
		border: '1px solid grey',
		cursor: 'pointer',
	},
	profileImg: {
		width: '190px',
		border: '1px solid grey',
	}
}

class Edit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'UPDATE CANDIDATE',
			isRedirect: false,
			showLoader: false,
			showFullLoader: false,
			showAddModal: false,
			categories: [],
			qualifications: [],
			subjects: [],
			universities: [],
			edata: [],
			croppedImage: '',
			openPersonalInfo: true,
			openQualificationInfo: true,
			openOtherInfo: true,
			uploadfiles: [],
			toggleActive: false,
			ifMarried: false,
			photoname: '',
			isadd: false,
			qualinfo: [],
			qindex: null,
			i__for: ''
		}

		this.onChange = this.onChange.bind(this);
		this.getSignatureFiles = this.getSignatureFiles.bind(this);
		this.handleFiles = this.handleFiles.bind(this);
		this.handleCropChange = this.handleCropChange.bind(this);
		this.onhandleChange = this.onhandleChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	onhandleChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onEdit(index, e) {
		var d = this.state.qualinfo[index];
		this.setState({
			i__for: d.coursetype,
			i__qualification: d.qualification,
			i__major: d.major,
			i__passyear: d.passyear,
			i__passmonth: d.passmonth,
			i__passclass: d.passclass,
			i__major: d.major,
			i__university: d.university,
			i__college: d.college,
			isadd: true, qindex: index
		});
	}

	onRemove(index, e) {
		this.state.qualinfo.splice(index, 1);
		this.setState({ qualinfo: this.state.qualinfo });
	}

	onAdd(e) {
		var index = this.state.qindex;
		if (index == null) {
			this.state.qualinfo.push({ coursetype: $("#i__for").val(), qualification: $("#i__qualification").val(), major: $("#i__major").val(), passyear: $("#i__passyear").val(), passmonth: $("#i__passmonth").val(), passclass: $("#i__passclass").val(), university: $("#i__university").val(), college: $("#i__college").val() });
		}
		else {
			this.state.qualinfo[index].coursetype = $("#i__for").val();
			this.state.qualinfo[index].qualification = $("#i__qualification").val();
			this.state.qualinfo[index].major = $("#i__major").val();
			this.state.qualinfo[index].passyear = $("#i__passyear").val();
			this.state.qualinfo[index].passmonth = $("#i__passmonth").val();
			this.state.qualinfo[index].passclass = $("#i__passclass").val();
			this.state.qualinfo[index].university = $("#i__university").val();
			this.state.qualinfo[index].college = $("#i__college").val();
		}
		this.setState({ qualinfo: this.state.qualinfo, isadd: false, i__for: '', qindex: null, i__qualification: '', i__major: '', i__passyear: '', i__passmonth: '', i__passclass: '', i__university: '', i__college: '' });

	}

	onMarriedToggle(field, e) {
		var d = this.state.edata;
		if (e) {
			this.state.ismarried = 1;
			d[field] = 1;
		}
		else {
			this.state.ismarried = 0;
			d[field] = 0;
		}
		this.setState({ ifMarried: !this.state.ifMarried, edata: d });
	}

	onToggle(field, e) {
		var d = this.state.edata;
		if (e) {
			this.state.iswidow = 1;
			d[field] = 1;
		}
		else {
			this.state.iswidow = 0;
			d[field] = 0;
		}
		this.setState({ toggleActive: !this.state.toggleActive, edata: d });
	}

	getSignatureFiles(files) {
		this.setState({ signature: files.base64, sign: files.fileList[0]['name'] });
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value, isadd: false });
	}

	//base64 photo
	handleFiles(files) {
		this.setState({ files: files.base64, photoname: files.fileList[0]['name'], show: true });
	}

	handleCropChange(crop) {
		this.setState({ crop: crop });
	}

	handleClose() {
		this.setState({ show: false, croppedImage: this.cropper.crop() });
	}

	componentDidMount() {

		this.loadCategory();
		this.loadQualifications();
		this.loadSubjects();
		this.loadUniversity();
		this.loadData();
	}

	loadData() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/getemployeebyid/' + this.state.masterId + '/' + this.state.companyId + '/' + this.props.match.params.id + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({
					edata: res['data'].data,
					qualinfo: res['data'].qinfo,
					img: res['data'].data['photo'],
					croppedImage: apiUrl + res['data'].data['photo'],
					signimg: res['data'].data['signature'],
					signature: apiUrl + res['data'].data['signature'],
					showFullLoader: false
				});
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadCategory() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ categories: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadQualifications() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('qualification/getactivequalifications/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ qualifications: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadSubjects() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('subject/getactivesubjects/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ subjects: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadUniversity() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('university/getactiveuniversities/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ universities: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Saving..' });
		var formData = Sanitize.objectifyForm($("#frmEmp").serializeArray());
		Reqst.axPost('employee/updateprofile', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				document.getElementById("frmEmp").reset();
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'UPDATE CANDIDATE', files: [], photoname: '', signature: [], sign: '' });
				this.loadData();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'UPDATE CANDIDATE' });
			}
		});
	}

	getValue(field) {
		var d = this.state.edata;
		return d[field];
	}

	setValue(field, e) {
		var d = this.state.edata;
		d[field] = e.target.value;
		if (field == 'application_for') {
			this.state.i__for = e.target.value;
		}
		this.setState({ edata: d });
	}

	setDobValue(field, e) {
		var d = this.state.edata;
		var val = e.target.value;
		var dob = d['dob'];
		if (dob == null) {
			var today = new Date();
			if (field == 'i__year') {
				d['dob'] = val + '-' + (today.getMonth()) + '-' + today.getDate();
			}
		}
		else {
			var today = new Date(dob);
			if (field == 'i__year') {
				d['dob'] = val + '-' + (today.getMonth() + 1) + '-' + today.getDate();
			}
			else if (field == 'i__month') {
				d['dob'] = today.getFullYear() + '-' + val + '-' + today.getDate();
			}
			else if (field == 'i__day') {
				d['dob'] = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + val;
			}
		}
		this.setState({ edata: d });
	}

	getQualifiName(qid) {
		var d = this.state.qualifications;
		var val = '';
		d.map((item, i) => {
			if (item.id == qid) {
				val = item.qualification
			}
		});
		return val;
	}

	getUniversityName(uid) {
		var d = this.state.universities;
		var val = '';
		d.map((item, i) => {
			if (item.id == uid) {
				val = item.universityname
			}
		});
		return val;
	}

	render() {

		let src = (this.state.files) ? this.state.files : 'https://www.freeiconspng.com/uploads/no-image-icon-11.PNG';
		var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		let YearList = [];
		YearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear() - 60); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		let dobYearList = [];
		dobYearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear() - 18); i >= ((new Date()).getFullYear() - 65); i--) {
			dobYearList.push(<option value={i}> {i} </option>);
		}

		let dobMonthList = [];
		dobMonthList.push(<option value=""> Month </option>);
		monthNames.map((item, i) => {
			dobMonthList.push(<option value={i}> {item} </option>);
		});

		let dobDateList = [];
		dobDateList.push(<option value="">Day</option>);
		for (var i = 1; i <= 31; i++) {
			dobDateList.push(<option value={i}> {i} </option>);
		}

		let cat = $("#i__postcategory").find(':selected').attr('data-cat');

		let cqualifications = [];
		this.state.qualifications.map((item, i) => {
			if (item.coursetype.toUpperCase() == this.state.i__for && item.coursecat == cat) {
				cqualifications.push(<option value={item.id}> {item.qualification} </option>)
			}
		});

		let subject = [];
		this.state.subjects.map((item, i) => {
			if (item.coursetype.toUpperCase() == this.state.i__for) {
				subject.push(<option value={item.id}> {item.subjectname} </option>)
			}
		});

		return (
			<div>
				<Helmet>
					<title>{appName} | Edit Candidate</title>
				</Helmet>
				<PageTitle title="Edit Candidate" loading={this.state.showLoader}>
					<div className="text-right">
						{Roles.Can('candidate', 'registration', 'canadd') ?
							<Link to="/candidate/registration" className="btn btn-info btn-sm" >
								<i className="fa fa-plus"></i>  Add Candidate
						</Link> : null}&nbsp;
						{Roles.Can('candidate', 'registration', 'canuse') ?
							<Link to="/candidate/list" className="btn btn-info btn-sm" >
								<i className="fa fa-list"></i> Candidate List
						</Link> : null}
					</div>
				</PageTitle>

				<form action="" id="frmEmp" method="post" encType="multipart/form-data" onSubmit={this.handleFormSubmit}>
					<input type="hidden" name="i__id" value={this.props.match.params.id} />
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<input type="hidden" name="i__photo" value={this.state.photoname} />
					<input type="hidden" name="i__files" value={this.state.croppedImage} />
					<input type="hidden" name="i__image" value={this.getValue('photo')} />
					<input type="hidden" name="i__ismarried" value={this.getValue('ismarried')} />
					<input type="hidden" name="i__iswidow" value={this.getValue('iswidow')} />
					<input type="hidden" name="i__signature" value={this.state.signature} />
					<input type="hidden" name="i__sign" value={this.state.sign} />
					<input type="hidden" name="i__signimage" value={this.getValue('signature')} />
					<input type="hidden" name="i__qinfo" value={JSON.stringify(this.state.qualinfo)} />
					<Row>
						<Col md={{ span: 10, offset: 1 }} >
							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openPersonalInfo: !this.state.openPersonalInfo }) }}
										aria-controls="form-personal-info"
										aria-expanded={this.state.openPersonalInfo} >
										{this.state.openPersonalInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Personal Info
								</Card.Title>
									<Collapse in={this.state.openPersonalInfo}>
										<div id="form-personal-info" style={{ padding: 10 }} >
											<Row>
												<Col md={9} >
													<Row>
														<Col md={3}>
															<label>Application & Register No<span className="text-danger">*</span></label>
														</Col>
														<Col md={5}>
															<div className="form-group">
																<input type="text" name="i__appno" id="i__appno" value={this.getValue('applicationno')} onChange={this.setValue.bind(this, 'applicationno')} className="form-control input-sm" placeholder="Application No" required />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__regno" id="i__regno" value={this.getValue('regno')} onChange={this.setValue.bind(this, 'regno')} className="form-control input-sm" placeholder="Register No" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>CATEGORY OF POST <span className="text-danger">*</span></label>
														</Col>
														<Col md={9} >
															<div className="form-group" >
																<select name="i__postcategory" id="i__postcategory" value={this.getValue('post_category')} onChange={this.setValue.bind(this, 'post_category')} className="form-control input-sm" required >
																	<option value="">Category</option>
																	{this.state.categories.map((item, i) => {
																		return (
																			<option value={item.id} data-cat={item.coursecat}>{item.categoryname}</option>
																		);
																	})}
																</select>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Name in Block Letters <span className="text-danger">*</span></label>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__title" id="i__title" value={this.getValue('title')} onChange={this.setValue.bind(this, 'title')} className="form-control input-sm" required >
																	<option value="Mr"> Mr </option>
																	<option value="Mrs"> Mrs </option>
																	<option value="Miss"> Miss </option>
																</select>
															</div>
														</Col>
														<Col md={7} >
															<div className="form-group" >
																<input type="text" name="i__name" id="i__name" value={this.getValue('name')} onChange={this.setValue.bind(this, 'name')} className="form-control input-sm" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Sex / DOB /Age <span className="text-danger">*</span></label>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__gender" id="i__gender" value={this.getValue('gender')} onChange={this.setValue.bind(this, 'gender')} className="form-control input-sm" required >
																	<option value="Male"> Male </option>
																	<option value="Female"> Female </option>
																	<option value="TG"> TG </option>
																</select>
															</div>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__year" id="i__year" value={Sanitize.getDobYear(this.getValue('dob'))} onChange={this.setDobValue.bind(this, 'i__year')} className="form-control input-sm" required >
																	{dobYearList}
																</select>
															</div>
														</Col>
														<Col md={2} style={{ padding: 0 }} >
															<div className="form-group" >
																<select name="i__month" id="i__month" value={Sanitize.getDobMonth(this.getValue('dob'))} onChange={this.setDobValue.bind(this, 'i__month')} className="form-control input-sm" required >
																	{dobMonthList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<div className="form-group" >
																<select name="i__day" id="i__day" value={Sanitize.getDobDay(this.getValue('dob'))} onChange={this.setDobValue.bind(this, 'i__day')} className="form-control input-sm" required >
																	{dobDateList}
																</select>
															</div>
														</Col>
														<Col md={1} style={{ paddingLeft: 0 }}>
															<div className="form-group">
																<input type="text" name="i__age" id="i__age" value={this.getValue('age')} onChange={this.setValue.bind(this, 'age')} className="form-control input-sm" placeholder="Age" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Place of Birth & District <span className="text-danger">*</span></label>
														</Col>
														<Col md={5} >
															<div className="form-group" >
																<input type="text" name="i__birthplace" id="i__birthplace" value={this.getValue('birth_place')} onChange={this.setValue.bind(this, 'birth_place')} className="form-control input-sm" placeholder="Birth Place" required />
															</div>
														</Col>
														<Col md={4} >
															<div className="form-group" >
																<input type="text" name="i__birthdistrict" id="i__birthdistrict" value={this.getValue('birth_district')} onChange={this.setValue.bind(this, 'birth_district')} className="form-control input-sm" placeholder="Birth District" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Religion & Denomination </label>
														</Col>
														<Col md={5} >
															<div className="form-group" >
																<select name="i__religion" id="i__religion" value={this.getValue('religion')} onChange={this.setValue.bind(this, 'religion')} className="form-control input-sm" required >
																	<option value="christian"> Christian </option>
																</select>
															</div>
														</Col>
														<Col md={4} >
															<div className="form-group" >
																<input type="text" name="i__denomination" id="i__denomination" value={this.getValue('denomination')} onChange={this.setValue.bind(this, 'denomination')} className="form-control input-sm" placeholder="Denomination" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Address </label>
														</Col>
														<Col md={9}>
															<div className="form-group" >
																<textarea name="i__address" id="i__address" value={this.getValue('address')} onChange={this.setValue.bind(this, 'address')} className="form-control input-sm" placeholder="Address" ></textarea>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Phone & Pincode</label>
														</Col>
														<Col md={5}>
															<div className="form-group" >
																<input type="text" name="i__phone" id="i__phone" value={this.getValue('phone')} onChange={this.setValue.bind(this, 'phone')} className="form-control input-sm" placeholder="Phone" />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group" >
																<input type="text" name="i__pincode" id="i__pincode" value={this.getValue('pincode')} onChange={this.setValue.bind(this, 'pincode')} className="form-control input-sm" placeholder="Pincode" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Mobile <span className="text-danger">*</span></label>
														</Col>
														<Col md={5}>
															<div className="form-group" >
																<input type="text" name="i__mobile" id="i__mobile" value={this.getValue('mobile')} onChange={this.setValue.bind(this, 'mobile')} className="form-control input-sm" placeholder="Mobile" required />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group" >
																<input type="text" name="i__mobile1" id="i__mobile1" value={this.getValue('mobile1')} onChange={this.setValue.bind(this, 'mobile1')} className="form-control input-sm" placeholder="Mobile1" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Email <span className="text-danger">*</span></label>
														</Col>
														<Col md={9}>
															<input type="email" name="i__email" id="i__email" value={this.getValue('email')} onChange={this.setValue.bind(this, 'email')} className="form-control input-sm" placeholder="Enter Valid Email" required />
														</Col>
													</Row>
												</Col>
												<Col md={3} >
													<Row>
														<Col md={12}>
															<div className="form-group">
																<ReactFileReader handleFiles={this.handleFiles} base64={true}>
																	{this.state.photoname == '' ?
																		<img src={(this.state.img == '' || this.state.img == null) ? "https://uae.microless.com/cdn/no_image.jpg" : this.state.croppedImage} style={styles.profileImg} /> :
																		<img src={this.state.croppedImage} style={styles.profileImg} />}
																</ReactFileReader>
																<Modal show={this.state.show} >
																	<Modal.Body>
																		<Cropper allowNewSelection={false}
																			src={src}
																			ref={ref => { this.cropper = ref }}
																			onChange={this.handleCropChange}
																		/>
																		<button type="button" onClick={this.handleClose} >Crop</button>
																	</Modal.Body>
																</Modal>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<div className="form-group">
																<label>Application Received On <span className="text-danger">*</span></label>
																<input type="date" name="i__appreceiveon" id="i__appreceiveon" value={this.getValue('app_receivedon')} onChange={this.setValue.bind(this, 'app_receivedon')} className="form-control input-sm" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<div className="form-group">
																<label>Registration Year <span className="text-danger">*</span></label>
																<select name="i__foryear" id="i__foryear" value={this.getValue('for_year')} onChange={this.setValue.bind(this, 'for_year')} className="form-control input-sm" required >
																	{YearList}
																</select>
															</div>
														</Col>
													</Row>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card>

							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openQualificationInfo: !this.state.openQualificationInfo }) }}
										aria-controls="form-education-info"
										aria-expanded={this.state.openQualificationInfo} >
										{this.state.openQualificationInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Qualification Info
								</Card.Title>
									<Collapse in={this.state.openQualificationInfo}>
										<div id="form-education-info" style={{ padding: 6 }}>
											{this.state.qualinfo.length > 0 ?
												<Row>
													<Col md={12}>
														<table width="100%" className="table table-bordered">
															<thead>
																<tr>
																	<th>S.No</th>
																	<th>Course Type</th>
																	<th>Qualification</th>
																	<th>Univeristy</th>
																	<th>College</th>
																	<th>Passing Year & Month</th>
																	<th>Passing Class</th>
																	<th></th>
																</tr>
															</thead>
															<tbody>
																{this.state.qualinfo.map((item, i) => {
																	return (
																		<tr key={i}>
																			<td>{i + 1}</td>
																			<td>{item.coursetype}</td>
																			<td>{this.getQualifiName(item.qualification)}</td>
																			<td>{this.getUniversityName(item.university)}</td>
																			<td>{item.college}</td>
																			<td>{item.passyear == '' ? '-' : item.passyear} & {item.passmonth == '' ? '-' : Sanitize.getMonthName(item.passmonth)}</td>
																			<td>{item.passclass}</td>
																			<td width="70">
																				<button type="button" className="btn btn-info btn-xs" onClick={this.onEdit.bind(this, i)}><i className="fa fa-edit"></i></button>&nbsp;
																		<button type="button" className="btn btn-danger btn-xs" onClick={this.onRemove.bind(this, i)}><i className="fa fa-remove"></i></button>
																			</td>
																		</tr>
																	)
																})}
															</tbody>
														</table>
													</Col>
												</Row> : ''}
											<Row>
												<Col md={2}>
													<label>Qualification for</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<select name="i__for" id="i__for" onChange={this.onChange} value={this.state.i__for} className="form-control input-sm">
															<option value="">Select</option>
															<option value="PG">PG</option>
															<option value="UG">UG</option>
														</select>
													</div>
												</Col>
												<Col md={1}>
													<button type="button" className="btn btn-info btn-xs" onClick={() => { this.setState({ isadd: true }) }}><i className="fa fa-plus" />&nbsp;Add</button>
												</Col>
											</Row>
											{(this.state.i__for != '' && this.state.isadd == true) ?
												<React.Fragment>
													<Row >
														<Col md={2}>
															<label>Qualification</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__qualification" id="i__qualification" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__qualification}>
																	<option value="">Qualification</option>
																	{cqualifications}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>Major Subject</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__major" id="i__major" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__major}>
																	<option value="">Major Subject</option>
																	{subject}
																</select>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={2}>
															<label>Passing Year & Month</label>
														</Col>
														<Col md={2}>
															<div className="form-group">
																<select name="i__passyear" id="i__passyear" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__passyear}>
																	{YearList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<div className="form-group">
																<select name="i__passmonth" id="i__passmonth" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__passmonth}>
																	{dobMonthList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>Class</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__passclass" id="i__passclass" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__passclass} />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={2}>
															<label>University</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__university" id="i__university" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__university}>
																	<option value="">University</option>
																	{this.state.universities.map((item, i) => {
																		return (
																			<option value={item.id}>{item.universityname}</option>
																		);
																	})}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>College Name</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__college" id="i__college" className="form-control input-sm" onChange={this.onhandleChange} value={this.state.i__college} />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<button type="button" style={{ float: 'right' }} className="btn btn-primary btn-xs" onClick={this.onAdd.bind(this)}><i className="fa fa-plus" />&nbsp;{this.state.qindex == null ? 'Add' : this.state.qindex == 0 ? 'Update' : 'Update'}</button>
														</Col>
													</Row>
												</React.Fragment> : ''}
											<Row>
												<Col md={12}>
													<b style={{ fontSize: '16px' }}>NON GRADUATES :</b>
												</Col>
											</Row><hr style={{ margin: '10px' }} />
											<Row>
												<Col md={6}>
													<Card>
														<Card.Header>
															<Card.Title>Highest Education</Card.Title>
														</Card.Header>
														<Card.Body>
															<Row>
																<Col md={4}>
																	<label>Passing Year & Month</label>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__hspassyear" id="i__hspassyear" value={this.getValue('hs_passyear')} onChange={this.setValue.bind(this, 'hs_passyear')} className="form-control input-sm" >
																			{YearList}
																		</select>
																	</div>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__hspassmonth" id="i__hspassmonth" value={this.getValue('hs_passmonth')} onChange={this.setValue.bind(this, 'hs_passmonth')} className="form-control input-sm" >
																			{dobMonthList}
																		</select>
																	</div>
																</Col>
															</Row>
															<Row>
																<Col md={4}>
																	<label>Institution Name</label>
																</Col>
																<Col md={8}>
																	<div className="form-group">
																		<input type="text" name="i__hsinstitution" id="i__hsinstitution" value={this.getValue('hs_institution')} onChange={this.setValue.bind(this, 'hs_institution')} className="form-control input-sm" />
																	</div>
																</Col>
															</Row>
														</Card.Body>
													</Card>
												</Col>
												<Col md={6}>
													<Card>
														<Card.Header>
															<Card.Title>SSLC</Card.Title>
														</Card.Header>
														<Card.Body>
															<Row>
																<Col md={4}>
																	<label>Passing Year & Month</label>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__sslcpassyear" id="i__sslcpassyear" value={this.getValue('sslc_passyear')} onChange={this.setValue.bind(this, 'sslc_passyear')} className="form-control input-sm" >
																			{YearList}
																		</select>
																	</div>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__sslcpassmonth" id="i__sslcpassmonth" value={this.getValue('sslc_passmonth')} onChange={this.setValue.bind(this, 'sslc_passmonth')} className="form-control input-sm" >
																			{dobMonthList}
																		</select>
																	</div>
																</Col>
															</Row>
															<Row>
																<Col md={4}>
																	<label>Institution Name</label>
																</Col>
																<Col md={8}>
																	<div className="form-group">
																		<input type="text" name="i__sslcinstitution" id="i__sslcinstitution" value={this.getValue('sslc_institution')} onChange={this.setValue.bind(this, 'sslc_institution')} className="form-control input-sm" />
																	</div>
																</Col>
															</Row>
														</Card.Body>
													</Card>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card>

							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openOtherInfo: !this.state.openOtherInfo }) }}
										aria-controls="form-other-info"
										aria-expanded={this.state.openOtherInfo} >
										{this.state.openOtherInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Other Info
								</Card.Title>
									<Collapse in={this.state.openOtherInfo}>
										<div id="form-other-info" style={{ padding: 6 }}>
											<Row>
												<Col md={2}>
													<label>Languages Known</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__language_known" id="i__language_known" value={this.getValue('language_known')} onChange={this.setValue.bind(this, 'language_known')} className="form-control input-sm" />
													</div>
												</Col>
												<Col md={2}>
													<label>Teaching Language</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__teaching_language" id="i__teaching_language" value={this.getValue('teaching_language')} onChange={this.setValue.bind(this, 'teaching_language')} className="form-control input-sm" />
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>Experience</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" onKeyPress={Sanitize.integerKeyPress} name="i__experience" id="i__experience" value={this.getValue('experience')} onChange={this.setValue.bind(this, 'experience')} className="form-control input-sm" placeholder="Experience" />
													</div>
												</Col>
												<Col md={2}>
													<label>Place of Experience</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__experienceplace" id="i__experienceplace" value={this.getValue('experience_place')} onChange={this.setValue.bind(this, 'experience_place')} className="form-control input-sm" placeholder="Place of Experience" />
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>If married, Is the wife / husband employed ?</label>
												</Col>
												<Col md={1}>
													<div className="form-group">
														<Toggle onClick={this.onMarriedToggle.bind(this, 'ismarried')} on={<span>YES</span>} off={<span>NO</span>} size="xs" offstyle="danger" active={this.getValue('ismarried') == 1 ? true : false} />
													</div>
												</Col>
												<Col md={3}>
													{this.getValue('ismarried') == 1 ?
														<div className="form-group">
															<input type="text" name="i__naturework" id="i__naturework" value={this.getValue('natureofwork')} onChange={this.setValue.bind(this, 'natureofwork')} className="form-control input-sm" placeholder="Nature of work" />
														</div> : ''}
												</Col>
												{this.getValue('ismarried') == 1 ?
													<Col md={2}>
														<label>Place of Employment</label>
													</Col> : ''}
												{this.getValue('ismarried') == 1 ?
													<Col md={4}>
														<div className="form-group">
															<input type="text" name="i__empplace" id="i__empplace" value={this.getValue('employment_place')} onChange={this.setValue.bind(this, 'employment_place')} className="form-control input-sm" placeholder="Place of Employment" />
														</div>
													</Col> : ''}
												<Col md={2}>
													<label>Are you a Widow?</label>
												</Col>
												<Col md={2}>
													<div className="form-group">
														<Toggle onClick={this.onToggle.bind(this, 'iswidow')} on={<span>YES</span>} off={<span>NO</span>} size="xs" offstyle="danger" active={this.getValue('iswidow') == 1 ? true : false} />
													</div>
												</Col>
												<Col md={2}>
													{/*
												<ReactFileReader handleFiles={this.getFiles.bind(this)}>
													<button className='btn btn-info btn-xs'>Upload Certificate</button>
												</ReactFileReader> */}
												</Col>
												<Col md={2}>
													<label>Signature</label>
												</Col>
												<Col md={2}>
													<div className="form-group">
														<ReactFileReader fileTypes={[".jpg", ".png", ".jpeg", ".bmp"]} base64={true} handleFiles={this.getSignatureFiles}>
															<button type="button" className='btn btn-info btn-xs'>Upload Signature</button>
														</ReactFileReader>
													</div>
												</Col>
												<Col md={2}>
													{(this.state.signimg == '' || this.state.signimg == null) ? this.state.sign :
														<div className="form-group">
															<img src={this.state.signature} width="125px" style={{ border: '1px solid #cacaca' }} />
														</div>}
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>Date <span className="text-danger">*</span></label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="date" name="i__date" id="i__date" value={this.getValue('app_date')} onChange={this.setValue.bind(this, 'app_date')} className="form-control input-sm" required />
													</div>
												</Col>
												<Col md={2}>
													<label>Place <span className="text-danger">*</span></label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__place" id="i__place" value={this.getValue('app_place')} onChange={this.setValue.bind(this, 'app_place')} className="form-control input-sm" required />
													</div>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card><br />
							<Row>
								<Col md={12}>
									<div className="text-right" >
										<button type="submit" className="btn btn-success btn-sm" disabled={this.state.saveText != 'UPDATE CANDIDATE'} >
											<i className="fa fa-check"></i> {this.state.saveText}
										</button>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Edit;